/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateSubLimitSettingsPayloadDto
 */
export interface UpdateSubLimitSettingsPayloadDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateSubLimitSettingsPayloadDto
     */
    subLimitSettingId: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateSubLimitSettingsPayloadDto
     */
    fire: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateSubLimitSettingsPayloadDto
     */
    wind: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateSubLimitSettingsPayloadDto
     */
    earthquake: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateSubLimitSettingsPayloadDto
     */
    flood: boolean;
}

/**
 * Check if a given object implements the UpdateSubLimitSettingsPayloadDto interface.
 */
export function instanceOfUpdateSubLimitSettingsPayloadDto(value: object): value is UpdateSubLimitSettingsPayloadDto {
    if (!('subLimitSettingId' in value) || value['subLimitSettingId'] === undefined) return false;
    if (!('fire' in value) || value['fire'] === undefined) return false;
    if (!('wind' in value) || value['wind'] === undefined) return false;
    if (!('earthquake' in value) || value['earthquake'] === undefined) return false;
    if (!('flood' in value) || value['flood'] === undefined) return false;
    return true;
}

export function UpdateSubLimitSettingsPayloadDtoFromJSON(json: any): UpdateSubLimitSettingsPayloadDto {
    return UpdateSubLimitSettingsPayloadDtoFromJSONTyped(json, false);
}

export function UpdateSubLimitSettingsPayloadDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateSubLimitSettingsPayloadDto {
    if (json == null) {
        return json;
    }
    return {
        
        'subLimitSettingId': json['subLimitSettingId'],
        'fire': json['fire'],
        'wind': json['wind'],
        'earthquake': json['earthquake'],
        'flood': json['flood'],
    };
}

export function UpdateSubLimitSettingsPayloadDtoToJSON(json: any): UpdateSubLimitSettingsPayloadDto {
    return UpdateSubLimitSettingsPayloadDtoToJSONTyped(json, false);
}

export function UpdateSubLimitSettingsPayloadDtoToJSONTyped(value?: UpdateSubLimitSettingsPayloadDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'subLimitSettingId': value['subLimitSettingId'],
        'fire': value['fire'],
        'wind': value['wind'],
        'earthquake': value['earthquake'],
        'flood': value['flood'],
    };
}

